module.exports = __webpack_public_path__ + "static/media/bed-alt.c3a13d98.svg";